// Widget Scripts
import cardWidgetTimes from './js/widgets/cardWidgetTimes.js';
import swiperWidget from './js/widgets/swiperWidget.js';
import cardWidgetOne from './js/widgets/cardWidgetOne.js';
import cardWidgetTwo from './js/widgets/cardWidgetTwo.js'; 
import cssSponsors from './js/widgets/cssSponsors.js';
import { facebookfeed, instafeed } from './js/widgets/socialNetworkWidget.js';
import cardWidgetThree from './js/widgets/cardWidgetThree.js';

// Custom Theme Scripts
import './js/localjs.js';

// Initialize Homepage Widgets
if (window.location.pathname === '/') {
  $(document).ready(function() {
    swiperWidget();
    cardWidgetOne();
    cardWidgetTwo();
    facebookfeed(true);
    instafeed();
    cardWidgetThree();
  });
}

$(document).ready(function() {
  cardWidgetTimes();
  cssSponsors();
});